import { inject } from 'inversify';

import { UserController } from '@/controllers/UserController';
import { service } from '@/decorators/service';
import { SignalrListener } from '@/decorators/signalr';
import { Logger } from '@/services/Logger';
import { Signalr } from '@/services/signalr/Signalr';
import { TripNoteTypeStore } from '@/stores/TripNoteTypeStore';
import { mapValueProperty } from '@/utils/mapValueProperty';
import { orderByField } from '@/utils/orderBy';
import { IListItem } from '~/api/IListItem';

@SignalrListener
@service(TripNoteTypeManager)
export class TripNoteTypeManager {
  @inject(Logger) protected logger: Logger;
  @inject(Signalr) protected signalr: Signalr;
  @inject(UserController) protected userController: UserController;
  @inject(TripNoteTypeStore) protected tripNoteTypeStore: TripNoteTypeStore;

  find(id: string) {
    return this.tripNoteTypeStore.find(id);
  }

  get all() {
    return orderByField(this.tripNoteTypeStore.all(), this.tripNoteTypeStore.valueKey);
  }

  reset() {
    this.tripNoteTypeStore.set([]);
  }

  updateTripNoteTypes(tripNoteTypes: IListItem[]) {
    // Used mapValueProperty as value is coming in as null
    this.tripNoteTypeStore.update(...mapValueProperty(tripNoteTypes));
  }
}
